import { LayoutHierarchy, MOBILE_HEADER_HEIGHT } from '@/constants';
import { SHIPMENT_CARD_MARGIN_BOTTOM } from '@/modules/pmt/constants';
import styled from 'styled-components';

const SHIPMENT_LIST_DESKTOP_MAX_HEIGHT = 796;
const SCROLL_BAR_WIDTH = 5;

export const ShipmentListWrapper = styled.div<{ hasEmailAccounts?: boolean }>(({ theme, hasEmailAccounts }) => ({
  padding: theme.spacing[20],
  paddingBottom: hasEmailAccounts ? 0 : theme.spacing[20],
  backgroundColor: theme.colors.pageBackground,

  '> *:not(:last-of-type)': {
    marginBottom: `${theme.spacing[SHIPMENT_CARD_MARGIN_BOTTOM]} !important`,
  },

  [`${theme.mediaBreakpointUp.lg}`]: {
    padding: theme.spacing[20],
    paddingRight: theme.spacing[16],
    backgroundColor: 'unset',
    overflowY: 'auto',
    maxHeight: SHIPMENT_LIST_DESKTOP_MAX_HEIGHT,

    '::-webkit-scrollbar': {
      width: SCROLL_BAR_WIDTH,
    },

    '::-webkit-scrollbar-track': {
      background: theme.colors.hoverBlack,
      borderRadius: 8,
    },

    '::-webkit-scrollbar-thumb': {
      background: theme.colors.scrollBarThumb,
      borderRadius: 8,
    },
  },
}));

export const ShipmentFiltersWrapper = styled.div(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: theme.spacing[8],
  padding: `${theme.spacing[8]} ${theme.spacing[20]}`,
  margin: 0,
  position: 'sticky',
  top: MOBILE_HEADER_HEIGHT,
  zIndex: LayoutHierarchy.Fourth,
  backgroundColor: theme.colors.highEmphasisWhite,
  borderTop: `1px solid ${theme.colors.focusedBlack}`,
  boxShadow: theme.elevation[2],

  '> div ': {
    width: '50%',

    '> button': {
      width: '100%',
    },
  },

  [`${theme.mediaBreakpointUp.lg}`]: {
    top: 0,
  },
}));

export const ListWithScrollbarWrapper = styled.div(({ theme }) => ({
  paddingRight: 0,

  [`${theme.mediaBreakpointUp.lg}`]: {
    paddingRight: theme.spacing[4],
  },
}));
